/**
 * Where the API and the staff app are — resolved at RUNTIME, not at build time.
 *
 * THIS IS WHAT MAKES `manager-web` PROMOTABLE.
 *
 * Vite inlines `import.meta.env` into the bundle, so an origin read that way is
 * frozen at `docker build`. That made this the one deployment unit of four that
 * INF-03's "promote the identical artefact to production" could not cover: its
 * dev image was not merely untested for production, it was *wrong* for it, and
 * `promote.sh` had to skip it while `api`, `ai-svc` and `staff-app-web` moved by
 * digest. A rebuild from the same commit produces a different image, and a
 * different image is a different thing to have tested.
 *
 * `/config.js` is written by `docker/10-write-config.sh` from container
 * environment before nginx starts, so the origin arrives at startup and one
 * image serves every environment — the same mechanism the staff app already uses
 * (`apps/staff-app/lib/api-base.ts`, ADR-0007).
 *
 * Runtime first, build-time second. The `import.meta.env` fallback is kept so
 * `pnpm dev` and a bare `vite build` still work with nothing generating
 * anything; `public/config.js` ships an empty object so the dev server has a
 * file to serve and the fallback is what applies there.
 */

declare global {
  var __FV_CONFIG__: { apiUrl?: string; staffUrl?: string } | undefined;
}

function runtime(key: 'apiUrl' | 'staffUrl'): string | undefined {
  const value = globalThis.__FV_CONFIG__?.[key];
  return typeof value === 'string' && value.length > 0 ? value : undefined;
}

/** The API origin. Undefined lets `@fieldvision/web-core` keep its own default. */
export function resolveApiBase(): string | undefined {
  return runtime('apiUrl') ?? import.meta.env['VITE_API_URL'];
}

/** The staff app's origin. Optional — only used for a cross-link. */
export function resolveStaffUrl(): string | undefined {
  return runtime('staffUrl') ?? import.meta.env['VITE_STAFF_URL'];
}

export {};
